import { IEnv } from './env.type'

export const environment: IEnv = {
  PRODUCTION: false,
  API_PREFIX: 'https://api.denistiaglin.com',
  SOCKET_PREFIX: 'wss://api.denistiaglin.com',
}
